<template>
    <div >
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>工作台</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `/customer-store-info/${storeid}` }" style="cursor: pointer">会员列表</el-breadcrumb-item>
            <el-breadcrumb-item>会员详情</el-breadcrumb-item>
        </el-breadcrumb>
        <br>
        <el-card>
            <div slot="header" style="font-size: 20px">
                <span>会员详情</span>
                <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0;font-size: 16px;" type="text" @click="getUserInfo"></el-button>
            </div>
            <div style="display: flex;padding: 10px 100px;">
                <div>
                    <el-image fit="cover" :src="face" style="width: 150px; height: 150px; border-radius: 50%;" :preview-src-list="[face]">
                        <div slot="error" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
                                <img src="@/assets/image/tx.png" style="width:150px;height:150px"  />
                        </div>
                    </el-image>
                </div>
                <div style="padding:20px 50px;font-size: 18px;width: 100%;">
                    <el-row :gutter="20">
                        <el-col :span="6"><div class="grid-content bg-purple">用户名：{{userInfo.username}}</div></el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">状态：
                                <el-tag type="success" v-if="userInfo.islock == 0">正常</el-tag>
                                <el-tag type="danger" v-if="userInfo.islock == 1">异常</el-tag>
                            </div>
                    </el-col>
                    <el-col :span="6">
                            <div class="grid-content bg-purple">教练：
                                <el-tag type="success" v-if="userInfo.role == 1">是</el-tag>
                                <el-tag type="danger" v-else>否</el-tag>
                            </div>
                        </el-col>
                        <el-col :span="6"><div class="grid-content bg-purple">创建时间：{{userInfo.adddate}}</div></el-col>
                    </el-row>
                    <br>
                    <br>
                    <el-row :gutter="20" v-show="userInfo.role == 1">
                        <el-col :span="18"><div class="grid-content bg-purple">关联门店：
                            <span v-for="(item,index) in storeInfo" :key="index" style="padding-right:10px;">
                                <span>{{item.storename}}</span>
                            </span>
                        </div></el-col>
                        <el-col :span="6"><div class="grid-content bg-purple">钱包余额：￥{{userInfo.account}}</div></el-col>
                    </el-row>
                </div>
            </div>
        </el-card>
        <br>
        <el-card>
            <el-tabs v-model="activeName" @tab-click="TabClick">
                <el-tab-pane label="进出记录" name="first">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>进出记录</span>
                            <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text" @click="getRecordList()"></el-button>
                        </div>
                        <div  v-if="recordList.length > 0">
                            <el-table :data="recordList" style="width: 100%" stripe size="middle" height="500">
                                <el-table-column label="ID" type="index" ></el-table-column>
                                <el-table-column label="用户名" prop="username" width="200"></el-table-column>
                                <el-table-column label="门店名称" prop="storename" width="300"  show-overflow-tooltip></el-table-column>
                                <el-table-column label="卡名" prop="cardname" width="400" show-overflow-tooltip></el-table-column>
                                <el-table-column label="状态" prop="type" width="150">
                                    <template slot-scope="scope">
                                        <span>
                                            <el-tag v-if="scope.row.type=='in'"  type="success">进门</el-tag>
                                            <el-tag v-else-if="scope.row.type=='out'" type="danger">出门</el-tag>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="时间" prop="recordtime"></el-table-column>
                            </el-table>
                            <br>
                            <div align="center">
                                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="queryInfo.pagenum" :page-sizes="[20,50,100,500]"  :page-size="queryInfo.pagesize"
                                layout="total, sizes, prev, pager, next" :total="total">
                                </el-pagination>
                            </div>
                        </div>
                        <el-empty v-else description="暂无记录"></el-empty>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="人脸管理" name="second" v-loading="Loading">
                    <div style="text-align: right;">
                        <el-button icon="el-icon-delete" type="primary" @click="DelFace(userInfo.username, userInfo.storeid)">删除人脸</el-button>
                        <el-button icon="el-icon-upload2" type="primary"  @click="triggerFileInput" >替换人脸</el-button>
                    </div>
                    <div style="height: 15px;"></div>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>人脸更换删除记录</span>
                            <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text" @click="getFaceList"></el-button>
                        </div>
                        <div  v-if="faceList.length > 0">
                            <el-table :data="faceList" style="width: 100%" stripe size="middle" height="500">
                                <el-table-column label="ID" type="index" ></el-table-column>
                                <el-table-column label="操作内容" prop="Content" width="500"  show-overflow-tooltip></el-table-column>
                                <el-table-column label="操作时间" prop="Adddate"></el-table-column>
                            </el-table>
                            <br>
                            <div align="center">
                                <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                                :current-page="queryInfo1.pagenum" :page-sizes="[20,50,100,500]"  :page-size="queryInfo1.pagesize"
                                layout="total, sizes, prev, pager, next" :total="total1">
                                </el-pagination>
                            </div>
                        </div>
                        <el-empty v-else description="暂无记录"></el-empty>
                    </el-card>
                    <input
                        ref="fileInput"
                        type="file"
                        accept="image/*"
                        style="display: none"
                        @change="handleImageSelect"
                    />
                </el-tab-pane>
                <el-tab-pane label="发会员卡" name="third"  v-loading="Loading">
                    <div style="text-align: right;">
                        <el-button icon="el-icon-present" type="primary"  @click="GiftCard">发放会员卡</el-button>
                    </div>
                    <div style="height: 15px;"></div>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>会员卡发放记录</span>
                            <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text"></el-button>
                        </div>
                        <div  v-if="giftCardList.length > 0">
                            <el-table :data="giftCardList" style="width: 100%" stripe size="middle" height="500">
                                <el-table-column label="ID" type="index" ></el-table-column>
                                <!-- <el-table-column label="管理员" prop="Username" width="200"></el-table-column> -->
                                <el-table-column label="操作内容" prop="Content" width="800"  show-overflow-tooltip></el-table-column>
                                <el-table-column label="操作时间" prop="Adddate"></el-table-column>
                            </el-table>
                            <br>
                            <div align="center">
                                <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                                :current-page="queryInfo2.pagenum" :page-sizes="[20,50,100,500]"  :page-size="queryInfo2.pagesize"
                                layout="total, sizes, prev, pager, next" :total="total2">
                                </el-pagination>
                            </div>
                        </div>
                        <el-empty v-else description="暂无记录"></el-empty>
                    </el-card>
                            <!--发卡对话框-->
                    <el-dialog title="手动发卡" :visible.sync="giftDialogVisible" width="60%" @close="giftDialogClosed">
                        <el-form :model="giftForm" :rules="giftFormRules" ref="giftFormRef" label-width="100px">
                            <el-form-item label="手机号" prop="username">
                              {{giftForm.username[0]}}
<!--                                <el-select v-model="giftForm.username" filterable  multiple placeholder="请选择会员手机号" style="width: 80%;" :remote="true" :remote-method="fetchUsernames" :loading="Loading">-->
<!--                                    <el-option-->
<!--                                    v-for="item in usernames"-->
<!--                                    :key="item.Id"-->
<!--                                    :label="item.Username"-->
<!--                                    :value="item.Username">-->
<!--                                    </el-option>-->
<!--                                </el-select>-->
                            </el-form-item>
                          <el-form-item label="使用门店" prop="storeid" v-if="storeid == null || storeid == undefined || storeid == ''">
                            <el-select filterable v-model="giftForm.storeid" @change="handleStoreChange" placeholder="请选择门店" style="width: 80%;">
                              <el-option
                                  v-for="item in stores"
                                  :key="item.Id"
                                  :label="item.Storename"
                                  :value="item.Id">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="会员卡" prop="cardid">
                              <el-select v-model="giftForm.cardid" @change="handleCardChange" placeholder="请选择会员卡" style="width: 80%;">
                                  <el-option
                                  v-for="item in cards"
                                  :key="item.Id"
                                  :label="`${item.Cardname} - ¥${item.Price}`"
                                  :value="item.Id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="giftDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="SaveGiftCard">确 定</el-button>
                        </span>
                    </el-dialog>
                    <!--发卡对话框-->
                </el-tab-pane>
                <el-tab-pane label="钱包管理" name="fourth" :disabled="isCoach">
                    <div style="height: 15px;"></div>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>提现记录</span>
                            <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text"></el-button>
                        </div>
                        <el-card>
                        <!-- {{this.txlist0}} -->
                            <el-table :data="txlist0"  :key="txlist0.id" style="width: 100%"  size="middle" height="50" :show-header="false" >
                                <el-table-column label="用户" prop="username"></el-table-column>
                                <el-table-column label="提现金额" prop="amount">
                                    <template slot-scope="scope">
                                    ￥{{scope.row.amount}}
                                </template>
                                </el-table-column>
                                <el-table-column label="提现时间" prop="reg_time"></el-table-column>
                                <el-table-column label="审核状态">
                                    <template>
                                        <el-tag type="warning">待审</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作">
                                    <!--作用域插槽-->
                                    <template slot-scope="scope">
                                        <!-- {{scope.row}} -->
                                        <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.sign" @change="TixianChecked(scope.row.id)"></el-switch>  <span style="color:#ff0000">审核</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                        <br>
                        <!-- {{ txlist1 }} -->
                        <el-card>
                            <el-table :data="txlist1"  :key="txlist1.id" style="width: 100%" stripe size="middle" height="300">
                                <el-table-column label="ID" type="index"></el-table-column>
                                <el-table-column label="提现单号" prop="orderno"></el-table-column>
                                <el-table-column label="用户" prop="username"></el-table-column>
                                <el-table-column label="提现金额" prop="amount">
                                    <template slot-scope="scope">
                                    ￥{{scope.row.amount}}
                                </template>
                                </el-table-column>
                                <el-table-column label="提现时间" prop="adddate"></el-table-column>
                                <el-table-column label="审核时间" prop="checktime"></el-table-column>
                                <el-table-column label="审核状态">
                                    <template>
                                        <el-tag type="success">已审</el-tag>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                        <!-- <el-empty description="暂无记录"></el-empty> -->
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="实名认证" name="five">
                    <div style="text-align: right;">
                        <el-button icon="el-icon-circle-check" type="primary">实名认证</el-button>
                    </div>
                    <div style="height: 15px;"></div>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>认证信息</span>
                            <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text"></el-button>
                        </div>
                        <el-empty description="暂无信息"></el-empty>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="学生认证" name="six">
                    <div style="text-align: right;">
                        <el-button icon="el-icon-circle-check" type="primary">学生认证</el-button>
                    </div>
                    <div style="height: 15px;"></div>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>认证信息</span>
                            <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text"></el-button>
                        </div>
                        <el-empty description="暂无信息"></el-empty>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="在线验劵" name="seven">
                    <el-card style="text-align: center;">
                        <el-select v-model="storeid" placeholder="请选择核销门店"  style="margin:0 10px;width: 300px;"  filterable>
                                <el-option v-for="item in storelist" :key="item.id" :label="item.Storename" :value="item.Id"></el-option>
                        </el-select>
                        <el-input placeholder="请输入劵码" v-model="code" class="input-with-select" style="width: 500px;">
                            <el-select v-model="type" slot="prepend" placeholder="请选择" style="width: 100px;">
                                <el-option label="抖音" value="1"></el-option>
                                <el-option label="美团" value="2"></el-option>
                            </el-select>

                            <el-button slot="append" icon="el-icon-circle-check" @click="CheckCoupons">验劵</el-button>
                        </el-input>
                    </el-card>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <br>
        <el-card>
            <div slot="header" style="font-size: 20px">
                <span>会员卡信息</span>
                <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0" type="text" @click="getCardList()"></el-button>
            </div>
            <div style="margin-bottom: 12px;">
                <span>归档状态：</span>
                <el-radio-group v-model="cardArchiveStatus" size="small" @change="onCardArchiveChange">
                    <el-radio-button label="N">否</el-radio-button>
                    <el-radio-button label="Y">是</el-radio-button>
                </el-radio-group>
            </div>
            <div>
                <el-row :gutter="10">
                    <!-- {{ cardList }} -->
                    <el-col :span="6" v-for="(card, index) in cardList" :key="index">
                        <div :class="card.status == 1 ? 'cardinfo1' : 'cardinfo'">
                            <div style="display: flex;justify-content: space-between;">
                                <div style="font-weight: bold;">{{card.cardname}}</div>
                                <div>{{card.days}}天</div>
                            </div>
                            <div style="display: flex;justify-content: space-between;">
                                <div >{{card.storename}}</div>
                                <div v-show="card.status == 1" style="text-align: right;">已过期</div>
                            </div>
                            <div style="font-size:14px">{{card.starttime}} 至 {{card.endtime}}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeName: 'first',
            userInfo:{},
            storeInfo:{},
            face:'',
            isCoach:false,
            code: '',
            storelist:[],
            type: '1',
            storeid:'',
            recordList:[],
            total: 0,
            queryInfo: {
                username:'',
                query: '',
                pagenum: 1,
                pagesize: 20
            },
            cardList:[],
            cardArchiveStatus: 'N',
            cardRequestSeq: 0,
            base64String: "",
            Loading: false,
            service_token:"",
            faceList:[],
            queryInfo1: {
                username:'',
                pagenum: 1,
                pagesize: 20
            },
            total1: 0,
            giftDialogVisible: false,
            giftForm:{
                username:[],
                cardid:'',
                storeid:'',
                remark:'',
                scope:'',
                istong:''
            },
            giftFormRules:{
                username:[
                    { required: true, message: '请选择手机号', trigger: 'blur' }
                ],
                cardid:[
                    { required: true, message: '请选择手机号', trigger: 'blur' }
                ],
                storeid:[
                    { required: true, message: '请选择门店', trigger: 'blur' }
                ],
            },
            usernames: [],
            cards:[],
            stores:[],
            giftCardList:[],
            queryInfo2: {
                username:'',
                pagenum: 1,
                pagesize: 20
            },
            total2: 0,
            txlist0:[],
            txlist1:[]
        }
    },
    mounted() {
      this.giftForm = {
        username:[],
        cardid:'',
        storeid:'',
        remark:'',
        scope:'',
        istong:''
      }
      this.storeid = this.$route.query.storeid
      if (this.storeid) {
        this.giftForm.storeid = this.storeid
      }
      this.username = this.$route.query.username
      this.giftForm.username = [this.username]
      this.service_token = window.sessionStorage.getItem('service_token')
        // console.log(this.service_token);
      this.getUserInfo()
    },
    methods: {
        async getUserInfo(){
          console.log()
            const { data:res } = await this.$http.get('users/'+this.username)

            // console.log(res);
            this.userInfo = res
            this.storeInfo = res.storeUsers
            this.face = this.ossURL + this.userInfo.username + '.png?t=' + Date.now();
            this.isCoach = this.userInfo.Role == 1 ? false : true
            this.queryInfo.username = this.userInfo.username
            this.getRecordList()
            this.getCardList()
        },
        async getRecordList(){
            // console.log(this.queryInfo);
            const { data:res } = await this.$http.get('records/',{ params: this.queryInfo })
            if(res.code == 0){
                this.recordList = res.data
                this.total = res.total
            }
        },
        onCardArchiveChange(){
            this.cardList = []
            this.getCardList()
        },
        async getCardList(){
            const mySeq = ++this.cardRequestSeq
            const { data:res } = await this.$http.get('user/cards',{ params: {username:this.username, archiveStatus:this.cardArchiveStatus }})
            if(mySeq !== this.cardRequestSeq) return
            if(res.code == 0){
                this.cardList = res.data
            }else{
                this.cardList = []
            }
        },
        handleSizeChange(newSize){
            this.queryInfo.pagesize = newSize
            this.getRecordList()
        },
        handleCurrentChange(newPage){
            this.queryInfo.pagenum = newPage
            this.getRecordList()
        },
        async DelFace(username, storeid){
            const confirmResult = await this.$confirm('确定要删除用户'+username+'的人脸照片吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm'){
                return this.$message.info('已取消！')
            }
            this.Loading = true;
            const { data: res} = await this.$http.post('/faces/delete',{ service_token:this.service_token, storeid, username })
            if(res.code == 0){
                this.getUserInfo()
                this.getFaceList()
                this.$message({message: '删除成功',type: 'success'})
                this.Loading = false;
            }else{
                this.$message.error(res.msg)
            }
        },
        // 触发文件选择
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        // 处理图片选择
        handleImageSelect(event) {
            const file = event.target.files[0];
            if (!file) return;

            // 检查是否是图片
            if (!file.type.match('image.*')) {
                this.$message.error('请选择图片文件（JPG/PNG等）');
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                // 去掉 data:image/jpeg;base64, 前缀
                const base64Data = e.target.result.split(',')[1]; // 只保留纯Base64部分
                this.base64String = base64Data;
                this.ReplaceFace(this.userInfo.username, this.userInfo.storeid)
            };
            reader.readAsDataURL(file);
        },
        async ReplaceFace(username, storeid){
            const confirmResult = await this.$confirm('确定要替换用户'+username+'的人脸照片吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm'){
                return this.$message.info('已取消！')
            }
            this.Loading = true;
            const { data: res} = await this.$http.post('/faces/replace',{ base64:this.base64String,service_token:this.service_token, storeid, username })
            if(res.code == 0){
                this.getUserInfo()
                this.getFaceList()
                this.$message({message: '替换成功',type: 'success'})
                this.Loading = false;
            }else{
                this.$message.error(res.msg)
            }
        },
        async getFaceList(){
            const { data:res } = await this.$http.get('faces/log',{ params: this.queryInfo })
            if(res.code == 0){
                this.faceList = res.data
                this.total1 = res.total
            }
        },
        handleSizeChange1(newSize){
            this.queryInfo1.pagesize = newSize
            this.getFaceList()
        },
        handleCurrentChange1(newPage){
            this.queryInfo1.pagenum = newPage
            this.getFaceList()
        },
        TabClick(tab) {
            if(tab.name == 'first'){
                this.getRecordList()
            }else if(tab.name == 'second'){
                this.getFaceList()
            }else if(tab.name == 'third'){
                this.getGiftCardList()
                this.getCardList()
            }else if(tab.name == 'fourth'){
                this.TiXian(this.userInfo.username)
            }else if(tab.name == 'seven'){
                this.GetStore()
            }
        },
        GiftCard(){
            this.giftDialogVisible = true
            if (this.giftForm.storeid) {
              this.getCards(this.giftForm.storeid)
            }
            this.getStores()
        },
        async getCards(storeid){
            const { data: res } = await this.$http.get('cards/all',{ params: {storeid: storeid}})
            if (res.code == 0) {
                this.cards = res.data.filter(card => card.cardclassid !== 3); // 过滤掉卡类ID为3的卡
            }
        },
        handleStoreChange(storeid) {
            this.getCards(storeid);
            // 重置卡片选择和相关字段
            this.giftForm.cardid = '';
            this.giftForm.scope = '';
            this.giftForm.istong = '';
        },
        async handleCardChange(cardid) {
            if (!cardid) {
                this.giftForm.scope = '';
                this.giftForm.istong = '';
                return;
            }

            // 查询选中卡片的详细信息
            try {
                const { data: res } = await this.$http.get(`cards/${cardid}`);
                if (res.code == 0 && res.data) {
                    const cardInfo = res.data;
                    // 设置scope和istong字段
                    this.giftForm.scope = cardInfo.scope || '';
                    this.giftForm.istong = cardInfo.istong || '';
                }
            } catch (error) {
                console.error('获取卡片详情失败:', error);
                this.$message.error('获取卡片详情失败');
            }
        },
        async getStores(){
            const { data: res } = await this.$http.get('stores/')
            if (res.code == 0) {
                this.stores = res.data
            }
        },
        async fetchUsernames(query) {
            if (query === '' || query.length < 6) { // 至少输入6个字符才查询
                this.usernames = [];
                return;
            }
            this.Loading = true;
            const { data: res } = await this.$http.get('users/all', { params:{ query:query } });
            if (res.code == 0) {
                this.usernames = res.data;
            }
            this.Loading = false;
        },
        giftDialogClosed(){
            this.$refs.giftFormRef.resetFields()
        },
        SaveGiftCard(){
            this.Loading = true
            this.$refs.giftFormRef.validate(async valid => {
                if (!valid) return
                this.giftForm.service_token = this.service_token
                const { data: res } = await this.$http.post('cards/gift',this.giftForm)
                if (res.code == 0) {
                    this.$message.success('发卡成功')
                    this.giftDialogVisible = false
                    this.getCardList()
                    this.getGiftCardList()
                    this.Loading = false
                }
            })
        },
        async getGiftCardList(){
            const { data:res } = await this.$http.get('cards/log',{ params: this.queryInfo })
            // console.log(res);
            if(res.code == 0){
                this.giftCardList = res.data
                this.total2 = res.total
            }
        },
        handleSizeChange2(newSize){
            this.queryInfo2.pagesize = newSize
            this.getGiftCardList()
        },
        handleCurrentChange2(newPage){
            this.queryInfo2.pagenum = newPage
            this.getGiftCardList()
        },
        async TiXian(username){
          const { data: res} = await this.$http.post('tixian/',{ username:username })
        //   console.log(res);
          if(res.code == 0){
            this.txlist0 = res.data.arr0
            this.txlist1 = res.data.arr1
          }
        },
        async TixianChecked(id){
            const confirmResult = await this.$confirm('确定要申请此提现吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm'){
                return this.$message.info('已取消删除！')
            }
            try {
                const loading = this.$loading({
                    lock: true,
                    text: '正在提现中，请勿关闭页面！',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const { data: res} = await this.$http.post('/tixian/check',{ id:id,service_token:this.service_token});

                if(res.code == 0){
                this.$message({message: '提现审核成功！',type: 'success'})
                this.TiXian(res.username)
                loading.close();
            }
            } catch (error) {
                console.error("请求出错：", error);
            }

      },
      async CheckCoupons(){
        if(this.storeid == ''){
            this.$message.error('请选择核销门店！')
            return
        }
        if(this.code == ''){
            this.$message.error('请输入劵码！')
            return
        }
        //判断劵码是否为数字
        if(!/^\d+$/.test(this.code)){
            this.$message.error('劵码只能为数字！')
            return
        }

        if(this.type == '1'){
            if(this.code.length != 15){
                this.$message.error('你输入的不是抖音劵码！')
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在验劵，请勿关闭页面！',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        //    console.log(this.userInfo.Id);
            const {data:res} = await this.$http.post("/coupon/douyin/check",{code:this.code,username:this.username,userid:this.userInfo.id,storeid:this.storeid,service_token:this.service_token})
            if(res.code == 0){
                this.$message.success('劵码验证成功！')
                this.getCardList()
                loading.close()
            }else{
                this.$message.error("劵码验证失败！")
                loading.close()
            }
        }
        if(this.type == '2'){
            if(this.code.length != 10){
                this.$message.error('你输入的不是美团劵码！')
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在验劵，请勿关闭页面！',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const {data:res} = await this.$http.post("/coupon/meituan/check",{code:this.code,username:this.username,userid:this.userInfo.id,storeid:this.storeid,service_token:this.service_token})
            if(res.code == 0){
                this.$message.success('劵码验证成功！')
                this.getCardList()
                loading.close()
            }else{
                this.$message.error("劵码验证失败！")
                loading.close()
            }
        }
      },
        async GetStore(){
            const { data: res } = await this.$http.get('stores/')
            if(res.code == 0){
                this.storelist = res.data
            }
       }
    }
}
</script>
<style scoped>
    .el-breadcrumb{
        margin: 0;
        font-size: 18px;
    }
    .el-tag{
        font-size: 16px;
    }
    /deep/.el-tabs__item{
        font-size: 18px;
        height: 50px;
    }
    .cardinfo{
        height: 100px;
        background-color:#fff2e2;
        border:1px dashed #ffb386;
        color:#ff7a45;
        border-radius: 10px;
        padding: 20px;
        font-size: 18px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .cardinfo1{
        height: 100px;
        background-color:#DCDFE6;
        border:1px dashed #909399;
        color:#909399;
        border-radius: 10px;
        padding: 20px;
        font-size: 18px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
